const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
  window.location.hostname === '[::1]' ||
  window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

export const rootURL = isLocalhost
  ? (process.env.REACT_APP_BACKEND_URL || 'http://localhost:8080')
  : `${window.location.protocol}//${window.location.host}/api`;

export const loginURL = rootURL + '/authentication/token/';

export const refreshTokenURL = rootURL + '/app/home/';

export const logoutURL = rootURL + '/authentication/logout/';


export const agentURL = process.env.REACT_APP_AGENT_URL || 'localhost:8001';
